import BreadCrumb from "../../../components/BreadCrumb";
import Layout from "../../../components/Layout";
import { Grid, Tooltip } from "@mui/material";
// import TextAreaGroup from "../../../components/FormComponent/TextAreaGroup";
import { toast } from "react-toastify";
import { Icon } from "@iconify/react";
import useStyles from "../styles";
import { useParams } from "react-router-dom";
import VerticalLine from "../../../assets/images/verticallines.svg";
import Button from "../../../components/Button";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/lab/TabList";
import parse from "html-react-parser";
import { useEffect, useState } from "react";
import { httprequest } from "../../../data/api";
import Modal from "../../../components/Modal";
import useValidator from "../../../hooks/useValidator";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import { useUserState } from "../../../context/UserContext";

const SUBJECT_NOTE_ENDPOINT = "/api/v1/lesson-outlines";
const COMMENT_API = "/api/v1/lesson-outlines/comments";
const TEACHER = "/api/v1/employees";
const ViewSubjectLessonNote = () => {
  const classes = useStyles();
  const { userRole } = useUserState();
  const isAdmin = userRole?.role_type === "school_admin";
  const [value, setValue] = useState("0");
  const [isReloadLoading, setIsReloadLoading] = useState(false);
  const [subjectNote, setSubjectNote] = useState([]);
  const { id } = useParams();
  // const [isLoading, setIsLoading] = useState(false);
  const [versionNote, setVersionNote] = useState([]);
  const [lessonNoteValidator, showLessonNoteValidator] = useValidator();
  const [comment, setComment] = useState({
    lesson_outline_version_id: "",
    comment: ""
  });
  const [replyToCommentId, setReplyToCommentId] = useState(null);
  const [replyComment, setReplyComment] = useState("");
  const [commentToDelete, setCommentToDelete] = useState("");
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isAssignReviewModalOpen, setIsAssignReviewModalOpen] = useState(false);
  const [teachers, setTeachers] = useState([]); // State for teachers
  const [selectedTeacher, setSelectedTeacher] = useState("");
  const [isApproveModalOpen, setIsApproveModalOpen] = useState(false);
  const [rejectModal, setRejectModal] = useState(false);

  /**
 * Loads the initial tab data by fetching the subject note and sets loading state.
 * @async
 */
  const handleInitialTabLoad = async () => {
    setIsReloadLoading(true);
    try {
      const res = await httprequest.get(`${SUBJECT_NOTE_ENDPOINT}/${id}`);
      setSubjectNote(res?.data?.data);
      setValue("0");
    } catch (err) {
      const errorMsg = err?.response?.data?.message || (typeof err?.response?.data === "string" ? err?.response?.data : "An error occurred");
      toast.error(errorMsg);
    } finally {
      setIsReloadLoading(false);
    }
  };

  /**
 * Fetches the subject note data for the current id.
 * @async
 */
  const handleGetNote = async () => {
    // setIsLoading(true);
    await httprequest
      .get(`${SUBJECT_NOTE_ENDPOINT}/${id}`)
      .then((res) => {
        setSubjectNote(res?.data?.data);
        // setIsLoading(false);
      })
      .catch((err) => {
        const errorMsg = err?.response?.data?.message || (typeof err?.response?.data === "string" ? err?.response?.data : "An error occurred");
        toast.error(errorMsg);
      });
  };

  /**
 * Fetches the subject note data for a specific version.
 * @async
 * @param {string} version_id - The ID of the version to fetch.
 */
  const handleVersionNote = async (version_id) => {
    try {
      const res = await httprequest.get(`${SUBJECT_NOTE_ENDPOINT}/${id}?version_id=${version_id}`);
      setVersionNote(res?.data?.data);
    } catch (err) {
      const errorMsg = err?.response?.data?.message || (typeof err?.response?.data === "string" ? err?.response?.data : "An error occurred");
      toast.error(errorMsg);
    }
  };

  /**
 * Handles tab change event and loads corresponding version note.
 * @param {Event} event - The tab change event.
 * @param {string} newValue - The new tab value (version ID).
 */
  const handleTabChange = (event, newValue) => {
    setValue(newValue);
    handleVersionNote(newValue);
  };

  /**
 * Updates the comment state on input change.
 * @param {Event} e - The input change event.
 */
  const handleCommentChange = (e) => {
    const { name, value } = e.target;
    setComment({ ...comment, [name]: value });
  };

  /**
 * Closes the assign review modal and resets selected teacher.
 */
  const closeAssignReviewModal = () => {
    setSelectedTeacher(""); // Reset selected teacher
    setIsAssignReviewModalOpen(false);
  };

  /**
 * Toggles the assign review modal open state.
 */
  const handleAssignReviewModal = () => {
    setIsAssignReviewModalOpen(!isAssignReviewModalOpen);
  };

  /**
 * Posts a new comment for the given lesson outline version.
 * @param {string} versionId - The ID of the lesson outline version.
 */
  const handlePostComment = (versionId) => {
    if (lessonNoteValidator.allValid()) {
      // setIsLoading(true);
      httprequest.post(COMMENT_API, { ...comment, lesson_outline_version_id: versionId })
        .then((res) => {
          handleGetNote();
          setComment((prev) => ({ ...prev, comment: "" }));
          toast.success(res?.data.message);
        }).catch((err) => {
          // setIsLoading(false);
          toast.error(err?.response?.data?.message);
        });
    } else {
      showLessonNoteValidator(true);
    }
  };

  /**
 * Posts a reply to a specific comment.
 * @async
 */
  const handleReplyComment = async () => {
    if (replyComment.trim() === "") {
      toast.error("Reply cannot be empty.");

      return;
    }

    try {
      await httprequest.post("/api/v1/lesson-outlines/comments/reply", {
        comment_id: replyToCommentId,
        reply: replyComment
      });
      toast.success("Reply submitted successfully.");
      setReplyComment("");
      setReplyToCommentId(null);
      handleGetNote();
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };
  /**
 * Fetches all teachers and sets the teachers state.
 */
  const getAllTeachers = () => {
    httprequest
      .get(TEACHER)
      .then((res) => {
        setTeachers(res?.data?.data?.employees);
      })
      .catch((err) => {
        const errorMsg = err?.response?.data?.message || (typeof err?.response?.data === "string" ? err?.response?.data : "An error occurred");
        toast.error(errorMsg);
      });
  };
  /**
 * Assigns the selected teacher as reviewer to the current lesson outline.
 */
  const handleAssignTeacher = () => {
    if (selectedTeacher) {
      setIsLoading(true);
      httprequest
        .post(`/api/v1/lesson-outlines/${subjectNote?.version_id}/review`, { reviewer: selectedTeacher })
        .then((res) => {
          toast.success(res?.data?.message);
          closeAssignReviewModal();
          setIsLoading(false);
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message);
          setIsLoading(false);
        });
    } else {
      toast.error("Please select a teacher.");
    }
  };

  /**
 * Closes the delete comment confirmation modal.
 */
  const handleCloseDeleteCommentModal = () => {
    setIsDeleteModalOpen(false);
  };

  /**
 * Deletes a comment by its ID.
 * @async
 * @param {string} comment_id - The ID of the comment to delete.
 */
  const handleCommentDelete = async (comment_id) => {
    try {
      await httprequest.delete(`${COMMENT_API}/${comment_id}`);
      setIsLoading(false);
      handleGetNote();
      handleCloseDeleteCommentModal();
      toast.success("Comment deleted successfully");
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };

  /**
 * Approves the current lesson outline.
 * @async
 */
  const approveLessonOutline = async (lesson_status) => {
    setIsLoading(true);
    httprequest
      .patch(`/api/v1/lesson-outlines/status/${subjectNote?.version_id}`, {
        status: lesson_status
      })
      .then((res) => {
        toast.success(res?.data?.message);
        setIsLoading(false);
        if (lesson_status === "approved") {
          setIsApproveModalOpen(false);
        } else {
          setRejectModal(false);
        }
        handleGetNote();
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        setIsLoading(false);
      });
  };

  /**
 * Opens or closes the delete comment modal and sets the comment to delete.
 * @param {string} commentId - The ID of the comment to delete.
 */
  const handleDeleteModal = (commentId) => {
    setCommentToDelete(commentId);
    setIsDeleteModalOpen(!isDeleteModalOpen);
  };
  /**
 * Updates the selected teacher based on the select input change.
 * @param {Event} e - The select input change event.
 */
  const handleTeacherSelectChange = (e) => {
    setSelectedTeacher(e.target.value);
  };
  useEffect(() => {
    handleGetNote();
    if (isAdmin) {
      getAllTeachers();
    }
  }, [isAdmin]);

  return (
    <Layout
      children={
        <>
          <div className="breadcrumb-container">
            <div>
              <BreadCrumb
                link_one="/lesson-notes-review"
                link_one_name="Lesson Notes Reviews"
                active="View Lesson Notes Reviews"
                description="See all lesson notes sent to you for review."
              />
            </div>
            <div className="flex justify-items-space flex-wrap-items-426">
              {isAdmin && (
                <div className="flex gap-10">
                  <Button
                    buttonIcon={ <Icon icon="hugeicons:user-add-02" /> }
                    variant="bgprimary"
                    buttonSize="fluid"
                    color="btnfontprimary"
                    buttonName="Assign Review"
                    onClick={handleAssignReviewModal}
                  />
                </div>
              )}
              <div className="flex gap-10">
                {(subjectNote?.status === "approved" || subjectNote?.status === "rejected") ? (
                  null
                ) : (
                  <div className="flex gap-10">
                    <Button
                      variant="deleteOutline"
                      buttonName="Reject"
                      buttonSize="medium"
                      color="btndanger"
                      onClick={() => setRejectModal(true)}
                    />
                    <Button
                      variant="primary"
                      buttonSize="medium"
                      color="btndefault"
                      buttonName="Approve"
                      onClick={() => setIsApproveModalOpen(true)}
                      isLoading={isLoading}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
          <TabContext value={value}>
            <Grid
              container
              spacing={2}
              sx={{
                "@media (max-width: 1000px)": {
                  flexWrap: "wrap-reverse"
                }
              }}
            >
              <Grid item lg={9} md={9} sm={12} xs={12}>
                <TabPanel value="0" sx={{ padding: "0px" }}>
                  <div className={`${classes.paddingcont}`}>
                    <div className={`${classes.parsercont} left-container`}>
                      {parse(subjectNote?.lesson_outline || "")}
                    </div>
                  </div>
                </TabPanel>
                {subjectNote?.updates?.map((update) => (
                  <TabPanel key={update?.version_id} value={update?.version_id} sx={{ padding: "0px" }}>
                    <div className={`${classes.paddingcont}`}>
                      <div className={`${classes.parsercont} left-container`}>
                        {parse(versionNote?.lesson_outline || "")}
                      </div>
                    </div>
                  </TabPanel>
                ))}
              </Grid>

              <Grid item lg={3} md={3} sm={12} xs={12}>
                <div className={`${classes.paddingcont}`}>
                  <div className={`${classes.rightcont} right-container`}>
                    <Tooltip title="This will load the current note outline" arrow>
                      <div className={classes.reload}>
                        {isReloadLoading ? <Icon icon="svg-spinners:270-ring-with-bg" width="20" height="20" />
                          : <Icon onClick={handleInitialTabLoad} icon="ooui:reload" width="20" height="20" />}
                      </div>
                    </Tooltip>
                    <div className={`${classes.notedetails}`}>
                      <div className={`${classes.notespan}`}>
                        <h5>Created By</h5>
                        <p>{subjectNote?.created_by?.last_name} {subjectNote?.created_by?.first_name}</p>
                      </div>
                      <div className={`${classes.notespan}`}>
                        <h5>Subject</h5>
                        <p>{subjectNote?.subject?.name}</p>
                      </div>
                      <div className={`${classes.notespan}`}>
                        <h5>Topic</h5>
                        <p>{subjectNote?.topic}</p>
                      </div>
                      <div className={`${classes.notespan}`}>
                        <h5>Method of Teaching</h5>
                        <p>{subjectNote?.training_method}</p>
                      </div>

                      {subjectNote && (
                        <Tabs
                          orientation="vertical"
                          value={value}
                          onChange={handleTabChange}
                          aria-label="subject note updates"
                        >
                          {subjectNote?.updates?.map((update) => (
                            <Tab
                              key={update?.version_id}
                              value={update?.version_id}
                              sx={{
                                padding: "0px",
                                alignItems: "unset",
                                "& .MuiTab-wrapper": {
                                  alignItems: "unset"
                                }
                              }}
                              className="tab-left"
                              label={
                                <>
                                  <div className="flex gap-10 align-items-center margin-top-10 margin-bottom-10 cursor-pointer">
                                    <Icon
                                      icon="lets-icons:check-fill"
                                      width="32"
                                      height="32"
                                      style={{ color: "#3FAC64" }}
                                    />
                                    <div>
                                      <h5>Updated at</h5>
                                      <div className="flex gap-5">
                                        <p>{update?.updated_at?.substring(0, 10)}</p>
                                        <p>|</p>
                                        <p>{update?.updated_at?.substring(11, 16)}</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className={classes.verticalline}>
                                    <img src={VerticalLine} alt="Vertical Line" />
                                  </div>
                                </>
                              }
                            />
                          ))}
                        </Tabs>
                      )}

                      <div className="flex gap-10 align-items-center margin-bottom-10">
                        <Icon
                          icon="mdi:cloud-clock-outline"
                          width="25"
                          height="25"
                          style={{
                            color: "#0e9504",
                            border: "1px solid #0e9504",
                            borderRadius: "20px",
                            padding: "5px",
                            marginLeft: "5px"
                          }}
                        />
                        <div>
                          <h5>Created at</h5>
                          <p>{subjectNote?.created_at?.substring(0, 10)}</p>
                        </div>
                      </div>

                      {/* Comments Section */}
                      <div className="margin-top-40">
                        <div className="text-align-left">
                          <Icon
                            icon="iconamoon:comment-fill"
                            width="20"
                            height="20"
                            style={{ color: "#111111" }}
                          />
                        </div>
                        <div className="margin-bottom-20">
                          <h4>Comment</h4>
                          <p>Review the lesson note by dropping your comment</p>
                        </div>
                        <div className="comment_div application_comment">
                          {subjectNote?.comments?.map((comment, index) => (
                            <div key={index} className={`admin_comment ${comment.ref_type === "reveiwer" ? "admin" : "applicant"}`}>
                              <div className="comment_main">
                                <div className="apply comment_container">
                                  <p className="no_margin">
                                    <strong>{comment.added_by.last_name} {comment.added_by.first_name}</strong>
                                  </p>
                                  <span className="admin_comment_span">{comment.comment}</span>
                                  {comment.ref_type === "reviewee" && (
                                    <span
                                      onClick={() => setReplyToCommentId(comment.id)}
                                      className="reply"
                                    >
            Reply
                                    </span>)}
                                </div>
                              </div>

                              {/* Display Replies */}
                              {comment.replies && comment.replies.length > 0 && (
                                <div className="replies">
                                  {comment.replies.map((reply, replyIndex) => (
                                    <div style={{ marginTop: "8px" }} key={replyIndex} className={`reply_container_${comment.ref_type === "reveiwer" ? "admin" : "applicant"}`}>

                                      <div className="reply_main">
                                        <p className="reply-user no_margin">
                                          <strong>{reply.last_name} {reply.first_name}</strong>
                                        </p>
                                        <div className="original-comment">
                                          <div className="reply_com">
                                            <span>{comment.comment}</span>
                                          </div>
                                          <span>{reply.reply}</span>
                                        </div>

                                        {comment.ref_type === "reveiwer" && (
                                          <span
                                            className="reply justify_end"
                                            onClick={() => setReplyToCommentId(reply.id)}
                                          >
                    Reply
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                        {replyToCommentId && (
                          <div className="reply_div">
                            <div className="selected-comment-to-reply">
                              <div>
                                <span>
                                  {subjectNote.comments.find(comment => comment.id === replyToCommentId)?.added_by.last_name}
                                  {subjectNote.comments.find(comment => comment.id === replyToCommentId)?.added_by.first_name}
                                </span>
                                <p className="no_margin">
                                  {subjectNote.comments.find(comment => comment.id === replyToCommentId)?.comment}
                                </p>
                              </div>
                              <button className="cancel_reply" onClick={() => setReplyToCommentId(null)}>
                                <Icon icon="ic:outline-cancel" />
                              </button>
                            </div>

                            {/* Reply text area */}
                            <textarea
                              className={`${classes.textarea}`}
                              value={replyComment}
                              onChange={(e) => setReplyComment(e.target.value)}
                              placeholder="Type your reply..."
                            />
                            <button className="upload_comment flex justify_end" onClick={handleReplyComment}>
      Reply Comment <Icon icon="zondicons:send" />
                            </button>
                          </div>
                        )}
                        {!replyToCommentId && (
                          <>
                            {subjectNote && (
                              <div className={`${classes.fortextarea} margin-top-12`}>
                                <textarea
                                  name="comment"
                                  className={`${classes.textarea}`}
                                  id=""
                                  value={comment?.comment}
                                  onChange={handleCommentChange}
                                />
                                {lessonNoteValidator.message("comment", comment?.comment, "required")}
                                <div className="flex gap-16 justifyRight">
                                  <div
                                    className={`${classes.submitreview} flex gap-10 align-items-center cursor-pointer`}
                                    onClick={() => handlePostComment(subjectNote?.version_id)}
                                  >
                                    <p>Make Comment</p>
                                    <Icon
                                      icon="iconamoon:send-fill"
                                      width="20"
                                      height="20"
                                      style={{ color: "#0065FF" }}
                                    />
                                  </div>
                                </div>
                              </div>
                            )}
                          </>)}
                      </div>
                    </div>
                  </div>
                </div>
              </Grid>
              {/* <ToastContainer /> */}
            </Grid>
          </TabContext>
          <Modal
            title="Delete Lesson Outline"
            subtitle="Are you sure you want to permanently delete this comment?"
            modalContent={<></>}
            modalFooter={
              <>
                <div className="flex gap-10">
                  <Button
                    variant="danger"
                    buttonName="Delete Comment"
                    buttonSize="full"
                    color="btndefault"
                    onClick={() => handleCommentDelete(commentToDelete)}
                    isLoading={isLoading}
                  />
                </div>
              </>
            }
            isopen={isDeleteModalOpen}
            closeModal={handleDeleteModal}
          />
          <Modal
            title="Assign Lesson Note Review"
            subtitle="Assign lesson note review to a teacher."
            modalContent={
              <>
                <Grid>
                  <SelectGroup
                    label="Teachers Name"
                    required
                    children={
                      <select onChange={handleTeacherSelectChange} value={selectedTeacher}>
                        <option value="">--- Select Teacher ---</option>
                        {teachers?.map((teacher) => (
                          <option key={teacher?.id} value={teacher?.employee_id}>
                            {teacher?.first_name} {teacher?.last_name}
                          </option>
                        ))}
                      </select>
                    }
                  />
                </Grid>
              </>
            }
            modalFooter={
              <>
                <div className="flex gap-10">
                  <Button
                    variant="primaryoutline"
                    buttonName="Cancel"
                    buttonSize="full"
                    color="btnfontprimary"
                    onClick={closeAssignReviewModal}
                  />
                  <Button
                    variant="primary"
                    buttonName="Confirm"
                    buttonSize="full"
                    color="btndefault"
                    onClick={handleAssignTeacher}
                    isLoading={isLoading}
                  />
                </div>
              </>
            }
            isopen={isAssignReviewModalOpen}
            closeModal={closeAssignReviewModal}
          />
          <Modal
            title="Approve Lesson Outline"
            subtitle="Are you sure you want to approve this lesson outline?"
            modalContent={<></>}
            modalFooter={
              <>
                <div className="flex gap-10">
                  <Button
                    variant="primary"
                    buttonName="Approve"
                    buttonSize="full"
                    color="btndefault"
                    onClick={() => approveLessonOutline("approved")}
                    isLoading={isLoading}
                  />
                </div>
              </>
            }
            isopen={isApproveModalOpen}
            closeModal={() => setIsApproveModalOpen(false)}
          />
          <Modal
            title="Reject Lesson Outline"
            subtitle="Are you sure you want to reject this lesson outline?"
            modalContent={<></>}
            modalFooter={
              <>
                <div className="flex gap-10">
                  <Button
                    variant="deleteOutline"
                    buttonName="Reject"
                    buttonSize="full"
                    color="btndanger"
                    onClick={() => approveLessonOutline("rejected")}
                  />
                </div>
              </>
            }
            isopen={rejectModal}
            closeModal={() => setRejectModal(false)}
          />

        </>
      }
    />
  );
};

export default ViewSubjectLessonNote;
